

<template>
    <div class="listmain ">
        <h1 class="firTitle">多轮对话</h1>
        <p>在多数语音交互场景下，用户的需求需要多次语音交互才能完成，为了打造更加自然的语音交互技能，开发者需要使用多轮对话功能。
       </p>
         <p>多轮对话主要分为两类连续对话场景：
       </p>
       <p>A.意图内的连续对话场景：<br>
Q1：北京今天天气怎么样？<br>
Q2：明天呢？<br>
Q2单独的问询语句是没有意义的，但是放在上下文环境中，用户的潜在意图是北京明天的天气怎么样
       </p>

        <p>B.跨意图的连续对话场景：<br>
Q1：北京今天天气怎么样？<br>
Q2：交通呢？<br>
Q2单独的问询语句槽位是缺失的，但是放在上下文环境中，用户的潜在意图是北京明天的交通怎么样
       </p>
        <p>开发者可以为每个意图设置一个或多个前置意图，以此进行意图或参数传递。开发者启用多轮对话开关后，可以对多轮对话功能进行配置
       </p>

         <h5 class="codeTitle">引用前置意图的值</h5>
        <p>引用前置意图后，点击槽位列表-值对参数进行引用
       </p>
        <h5 class="codeTitle">最长距离</h5>
        <p>开发者可以对参数传递的距离进行设置，默认为5（即参数在5轮对话后失效）
       </p>
        <h5 class="codeTitle">输出前置意图</h5>
        <p>如果开发者选择打开“输出前置意图”开关，那么在输出intent时，将输出前置意图的intent
意图内的连续对话场景往往需要打开”输出前置意图“开关
跨意图的连续对话场景往往需要关闭”输出前置意图“开关，即默认输出当前意图
       </p>




    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zygn_dldh.vue